"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SDK = exports.GRAPHQL_ENDPOINTS = exports.GPLCORE_PROGRAMS = void 0;
var anchor = __importStar(require("@project-serum/anchor"));
var connection_1 = require("./connection");
var constants_1 = require("./constants");
var post_1 = require("./post");
var profile_1 = require("./profile");
var reaction_1 = require("./reaction");
var user_1 = require("./user");
var session_1 = require("./session");
var gpl_core_json_1 = __importDefault(require("./idl/gpl_core.json"));
var gpl_session_json_1 = __importDefault(require("./idl/gpl_session.json"));
var profileMetadata_1 = require("./profileMetadata");
var constants_2 = require("./constants");
__createBinding(exports, constants_2, "GPLCORE_PROGRAMS");
var constants_3 = require("./constants");
__createBinding(exports, constants_3, "GRAPHQL_ENDPOINTS");
var SDK = /** @class */ (function () {
    function SDK(wallet, connection, opts, cluster, gqlClient) {
        this.user = new user_1.User(this);
        this.profile = new profile_1.Profile(this);
        this.profileMetadata = new profileMetadata_1.ProfileMetadata(this);
        this.connection = new connection_1.Connection(this);
        this.post = new post_1.Post(this);
        this.reaction = new reaction_1.Reaction(this);
        this.session = new session_1.Session(this);
        this.cluster = cluster;
        this.provider = new anchor.AnchorProvider(connection, wallet, opts);
        this.program = new anchor.Program(gpl_core_json_1["default"], constants_1.GPLCORE_PROGRAMS[this.cluster], this.provider);
        this.session_program = new anchor.Program(gpl_session_json_1["default"], constants_1.GPLSESSION_PROGRAMS[this.cluster], this.provider);
        this.rpcConnection = connection;
        this.gqlClient = gqlClient;
    }
    return SDK;
}());
exports.SDK = SDK;
